import { isLocalHost } from "shared/util/EnvironmentHelpers";

/**
 * Gets the root URL for composing image URLs.
 * @returns {string} The path at which images are served.
 */
export default function getImagePath() {
	return !isLocalHost
		? "https://cdn.okccdn.com/"
		: `https://okoffice.okcupid.com/images/users/${process.env.DEVJAIL_USERNAME}/oksrc/images/`;
}



// WEBPACK FOOTER //
// ./src/shared/util/getImagePath.js